export const SPRAY_EVENT_IDS_TABLE_PAGINATION_NAME = 'sprayEventIdsPage';
